import React from 'react';
import useFeatureToggleService from 'feature-toggle';
import { BaseFieldLayoutProps } from 'ui-builder';
import { cn } from 'shadcn-ui';

function LegacyTextFieldLayout(props: BaseFieldLayoutProps) {
  return (
    <span>{props.value || props.noDataMessage}</span>
  );
}

function ShadcnTextFieldLayout(props: BaseFieldLayoutProps) {
  return (
    <span className={cn('text-sm text-gray-800', props.className)}>
      {props.value || props.noDataMessage}
    </span>
  );
}

export default function TextFieldLayout(props: BaseFieldLayoutProps) {
  const { isShadcnUiEnabled } = useFeatureToggleService();

  if (isShadcnUiEnabled()) {
    return <ShadcnTextFieldLayout {...props} />;
  } else {
    return <LegacyTextFieldLayout {...props} />;
  }
}
